// A simple toast notification utility
import { toast as toastPrimitive } from '../components/ui/use-toast';

const toast = {
  success: (message: string) => {
    toastPrimitive({
      title: 'Sucesso',
      description: message,
      variant: 'default',
    });
  },
  error: (message: string) => {
    toastPrimitive({
      title: 'Erro',
      description: message,
      variant: 'destructive',
    });
  },
  warning: (message: string) => {
    toastPrimitive({
      title: 'Aviso',
      description: message,
      variant: 'default',
    });
  }
};

export default toast;
